<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="会议名称：">
        <el-select v-model="query.meetingId" placeholder="请选择" clearable filterable size="small">
          <el-option v-for="(item,index) in meetingOptions" :key="index" :label="item.title + (item.startTime ? ' (' + item.startTime.substring(0, 10) + ')' : '') + (item.userRealName ? ' [' + item.userRealName + ']' : '')" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报名状态：">
        <el-select v-model="activeName" placeholder="请选择" clearable size="small">
          <el-option label="未开始" :value="99"></el-option>
          <el-option label="待参会" :value="20"></el-option>
          <el-option label="已签到" :value="30"></el-option>
          <el-option label="已完成" :value="22"></el-option>
          <el-option label="已取消" :value="40"></el-option>
          <el-option label="撤回报名" :value="50"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="住宿信息：">
        <el-select v-model="query.isAssignStay" placeholder="请选择" clearable size="small">
          <el-option label="已分配" :value="1"></el-option>
          <el-option label="未分配" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报名时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import meetingApi from '@/api/meeting/meeting'
import meetingSignUpApi from '@/api/meeting/meetingSignUp'
export default {
  data() {
    return {
      dateTime: [],
      activityType: undefined,
      list: [],
      total: 0,
      listLoading: true,
      query: {

      },
      activeName: '',
      meetingOptions: []
    }
  },
  created() {
    this.getMeeting()
  },
  methods: {
    getMeeting() {
      this.formVisible = true
      //{ status: 10, statusSub: 23 }
      meetingApi.fetchListForMini().then(data => {
        this.meetingOptions = data.data
      })
    },
    handleDownload() {
      this.query.createdTimeStart = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.createdTimeEnd = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.query.statusSub = undefined
      this.query.status = undefined
      const activeStatus = this.activeName === '' || this.activeName === null || this.activeName === undefined
        ? undefined
        : Number(this.activeName)
      if (activeStatus !== undefined) {
        if (activeStatus === 22) {
          this.query.statusSub = activeStatus
          this.query.status = 30
        } else {
          this.query.statusSub = activeStatus === 99 ? 20 : undefined
          this.query.status = activeStatus === 99 ? 20 : activeStatus
        }
      }
      return this.$common.confirm('是否确认导出')
        .then(() => meetingSignUpApi.meetingExport(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>
